import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { InputsModule } from "../inputs";

import { InputTelComponent } from "./tel.component";

@NgModule({
  declarations: [InputTelComponent],
  imports: [CommonModule, InputsModule],
  exports: [InputTelComponent],
})
export class InputTelModule {}
